import {Hal} from './hal.model';
import {PagedHal} from './paged-hal.model';

export class CaseOverviewHal extends Hal {
  identification: string;
  name: string;
  description: string;
  reference: string;
  creationDate: Date;
  completedDate: Date;
  lastModifiedDate: Date;
  clientName: string;
  clientAdditionalInfo: string;
  assigneeName: string;
  state: string;
  externalCaseId: string;

  constructor(data: any) {
    super(data);
    this.identification = data.identification;
    this.name = data.name;
    this.description = data.description;
    this.reference = data.reference;
    this.creationDate = data.creationDate;
    this.completedDate = data.completedDate;
    this.lastModifiedDate = data.lastModifiedDate;
    this.clientName = data.clientName;
    this.clientAdditionalInfo = data.clientAdditionalInfo;
    this.assigneeName = data.assigneeName;
    this.state = data.state;
    this.externalCaseId = data.externalCaseId;
  }
}

export class PagedCaseOverviewHal extends PagedHal {
  _embedded: Embedded;
  processingPhaseEnabled: boolean;

  constructor(data: any) {
    super(data);
    this._embedded = new Embedded(data._embedded);
    this.processingPhaseEnabled = !!data.processingPhaseEnabled;
  }
}

class Embedded {
  caseOverviews: CaseOverviewHal[];

  constructor(data: any) {
    this.caseOverviews = data?.caseOverviews.map((data: any) => new CaseOverviewHal(data));
  }
}
